import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import TextArea from "../../components/form-controls/TextArea";
import InvalidFeedback from "../../components/InvalidFeedback";
import Tags from "../../components/Tags";
import { useTranslation } from "react-i18next";

function FormCloseNodePage({ node, onDelete, chatbotInfo }) {
    const { t } = useTranslation();

    const defaultValues = {
        _id: '',
        is_root: false,
        name: '',
        parent_nodes: [],
        keywords: [],
        type: 'CLOSE',
        close: {
            message: { es: '' },
            category: '',
        }
    }
    
    const { control, register, watch, getValues, setValue, reset, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const submit = async (data: any) => {
        data.position = node.position;
        
        await node.data.handleSaveNode({ nodeID: node.id, data, chatbotInfo })
    }

    useEffect(() => {
        reset(Object.assign(defaultValues, node.data ))
    }, [node.data])

    return (
        <>
            <div className="card-header">
                <h3 className="card-header-title">{t("platform.chatbot.finished-node.config-title")}</h3>
                <p className="m-0"><small className="text-muted">{t("platform.chatbot.finished-node.end-flow")}</small></p>
                { getValues('_id') && <p className="m-0"><small className="text-muted">Nodo id: {getValues('_id')}</small></p> }
            </div>
            <div className="card-body">
                <div className="mb-3">
                    <Input label={t("platform.chatbot.finished-node.name")} errors={errors.name} {...register('name', { required: true })} />
                </div>

                <div className="mb-3">
                    <TextArea
                        label={t("platform.chatbot.finished-node.message")}
                        errors={errors.close?.message?.['es'] }
                        value={watch('close.message.es').length}
                        counter={1024}
                        {...register('close.message.es', { required: true, maxLength: { value: 1024, message: '1024' } })} />
                </div>

                <div className="mb-3">
                    <Input label={t("platform.chatbot.finished-node.closure")} errors={errors.close?.category} {...register('close.category', { required: true })} />
                </div>
                

                <div className="d-grid gap-2 my-3 ">
                    <Button type="submit" className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                </div>

                {
                    getValues('_id') && (
                        <div className="d-grid gap-2 my-3 ">
                            <Button type="submit" className="btn btn-ghost-danger"  onClick={() => onDelete(getValues('_id')) }>{t("platform.chatbot.delete-node")}</Button>
                        </div>
                    )
                }


            </div>
        </>
    )
}
export default FormCloseNodePage